import CompanyService from "../services/CompanyService";
import { MapIf } from "./Utils";

export function parseJwt(token: string): any {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");

  const jsonPayload = decodeURIComponent(
    Buffer.from(base64, "base64")
      .toString()
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
  return JSON.parse(jsonPayload);
}

export function parseIntOrDefault(
  e: string | undefined | null,
  d?: number
): number {
  if (e === undefined || e === null) {
    return d ?? 0;
  }
  const p = parseInt(e);
  return Number.isInteger(p) ? p : (d ?? 0);
}

export function parseDate(value: string | undefined): Date | undefined {
  if (value === undefined || value === null) {
    return undefined;
  }
  let date = new Date();
  if (
    value.length === 8 /* yyyyMMdd */ ||
    value.length === 10 /* yyyy/MM/dd or yyyy-MM-dd */ ||
    value.length === 14 /* yyyyMMdd hh:mm */
  ) {
    if (value.length === 10) {
      value = value.replaceAll("/", "").replaceAll("-", "");
    }
    date.setFullYear(
      parseInt(value.substring(0, 4)),
      parseInt(value.substring(4, 6)) - 1,
      parseInt(value.substring(6, 8))
    );
    if (value.length === 14) {
      date.setHours(
        parseInt(value.substring(9, 11)),
        parseInt(value.substring(12, 14))
      );
    }
    if (!Number.isNaN(date.getTime())) {
      return date;
    }
  }
  date = new Date(value);
  if (!Number.isNaN(date.getTime())) {
    return date;
  }
  return undefined;
}

function addHours(date: Date, hours: number) {
  return new Date(date.getTime() + hours * 3_600_000 /* hs to ms */);
}

export function restTimezone(date: Date) {
  return addHours(date, -CompanyService.getTimezone() / 60);
}

export function addTimezone(date: Date) {
  return addHours(date, CompanyService.getTimezone() / 60);
}

export function MapIfHasHours(date: Date, map: (date: Date) => Date) {
  return MapIf(
    date,
    date.getHours() + date.getMinutes() + date.getMilliseconds() > 0,
    map
  );
}

/**
 * Verifica si un string de fecha tiene componente de hora (no es solo fecha)
 * @param dateString - String de fecha en formato ISO, yyyy-MM-dd, yyyy/MM/dd, etc.
 * @returns true si el string tiene componente de hora, false si es solo fecha
 */
export function hasTimeComponent(dateString: string | undefined): boolean {
  if (!dateString) return false;

  // Formato ISO con hora: "2024-01-15T14:30:00" o "2024-01-15T14:30:00Z"
  if (dateString.includes("T") && dateString.length > 10) {
    const timePart = dateString.split("T")[1];
    if (timePart) {
      // Verificar si tiene hora diferente de 00:00:00
      const timeMatch = timePart.match(/^(\d{2}):(\d{2})(?::(\d{2}))?/);
      if (timeMatch) {
        const hours = parseInt(timeMatch[1]);
        const minutes = parseInt(timeMatch[2]);
        const seconds = timeMatch[3] ? parseInt(timeMatch[3]) : 0;
        return hours > 0 || minutes > 0 || seconds > 0;
      }
    }
  }

  // Formato yyyyMMdd hh:mm (14 caracteres)
  if (dateString.length === 14) {
    const hours = parseInt(dateString.substring(9, 11));
    const minutes = parseInt(dateString.substring(12, 14));
    return hours > 0 || minutes > 0;
  }

  // Formato yyyyMMdd o yyyy-MM-dd o yyyy/MM/dd (8 o 10 caracteres) - solo fecha
  if (dateString.length === 8 || dateString.length === 10) {
    return false;
  }

  // Si no coincide con ningún formato conocido, asumimos que puede tener hora
  // y dejamos que MapIfHasHours lo verifique después del parseo
  return true;
}

export function validateMail(mail: string | undefined) {
  if (!mail) {
    return false;
  }
  return mail.includes("@") && mail.includes(".");
}

export function validateMailOrEmpty(mail: string | undefined) {
  if (!mail) {
    return true;
  }
  return mail.includes("@") && mail.includes(".");
}
